import React from "react";
import { Box, Typography } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

import DetailedCard from "../../Claims/DetailedCard";
import TruckSvg from "../../Icons/TruckSvg";
import ContactSupport from "./ContactSupport";
import TransportAlert from "../../VehicleCard/TransportAlert";

export const deliveryDescription =
  "Get your purchase delivered by plate driver or Transporter";
export const noDeliveryDescription =
  "This vehicle does not currently qualify for online delivery request. Please get in touch to discuss your options:";

const Container = styled(Box)`
  ${css({
    border: "normalBorder",
    borderRadius: 2,
  })}
`;

interface DeliveriesProps {
  isEnabled: boolean;
  requestDeliveryLink: string;
  bookDeliveryOnClickHandler?: () => void;
  callCustomerServiceOnClickHandler?: any;
  emailCustomerServiceOnClickHandler?: any;
  sundryMessage: string | null;
  isLateStorageFees?: boolean;
}

const Deliveries: React.FunctionComponent<DeliveriesProps> = ({
  isEnabled = false,
  requestDeliveryLink,
  bookDeliveryOnClickHandler,
  callCustomerServiceOnClickHandler = () => {},
  emailCustomerServiceOnClickHandler = () => {},
  sundryMessage,
  isLateStorageFees = false,
}) => {
  if (isEnabled)
    return (
      <DetailedCard
        width="100%"
        icon="truck"
        link={requestDeliveryLink}
        headline="Deliveries"
        label="Request Delivery"
        ariaLabel="Deliveries"
        showLinkAsButton={isLateStorageFees}
        iconColor="#1D2948"
        hoverBorderEnabled={false}
        additionalOnClickHandler={bookDeliveryOnClickHandler}
      >
        <Typography m={0} mt={8} mb={8}>
          {deliveryDescription}
        </Typography>

        {sundryMessage && (
          <TransportAlert message={sundryMessage} weight="bold" mb={4} />
        )}
      </DetailedCard>
    );
  return (
    <Container padding={6} paddingBottom={5}>
      <Box display="flex" justifyContent="space-between" height="100%">
        <Typography margin={0} variant="h4" color="#1D2948" fontWeight="bold">
          Deliveries
        </Typography>
        <Box
          display="flex"
          justifyContent="space-around"
          flexDirection="column"
          minHeight="100%"
        >
          <TruckSvg fill="#1D2948" />
        </Box>
      </Box>
      <Box>
        <Typography variant="body" m={0} mt={8} mb={8}>
          {noDeliveryDescription}
        </Typography>
        <ContactSupport
          callCustomerServiceOnClickHandler={callCustomerServiceOnClickHandler}
          emailCustomerServiceOnClickHandler={
            emailCustomerServiceOnClickHandler
          }
        />
      </Box>
    </Container>
  );
};

export default Deliveries;
